export default __webpack_public_path__ + "static/media/WomensHealth.6af3d71c.svg";